// Actions
export const API_RESPONSE_SUCCESS = 'API_RESPONSE_SUCCESS';
export const API_RESPONSE_ERROR = 'API_RESPONSE_ERROR';
export const GET_SCHEDULE = 'GET_SCHEDULE';
export const GET_SCHEDULE_BY_ID = 'GET_SCHEDULE_BY_ID';
export const CREATE_SCHEDULE = 'CREATE_SCHEDULE';
export const UPDATE_SCHEDULE = 'UPDATE_SCHEDULE';
export const UPDATE_SCHEDULE_REALIZED = 'UPDATE_SCHEDULE_REALIZED';
export const DELETE_SCHEDULE = 'DELETE_SCHEDULE';
